// Local with wiremock
export const environment = {
  VERSION: '1.0.26', // This is to make sure that we have the latest code in AWS
  env: 'default',
  mapsApiKey: 'AIzaSyAcWnmixm5fJp2zzXWF8O5uJHfDLJq3sfU'// 'AIzaSyAZ5_cQVONVpa8CRHEnbjR9QdeO_YCtNBY' // This is the dev key
};
